export default "__VITE_ASSET__27af971e__"